var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected > 0),expression:"selected > 0"}]},[_vm._v(" "+_vm._s(_vm.$t(_vm.text, { count: _vm.selected }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }